import React, { useState } from "react";
import "./InspirationGallery.scss";

import inspirationOne from "../../images/inspiration-1.jpg";
import inspirationTwo from "../../images/inspiration-2.jpg";
import inspirationThree from "../../images/inspiration-3.jpg";

const InspirationGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryItems = [
    {
      image: inspirationOne,
      alt: "Vestido elegante para XV años",
      label: "Momentos que brillan",
    },
    {
      image: inspirationTwo,
      alt: "Decoración elegante para fiesta de XV años",
      label: "Detalles que enamoran",
    },
    {
      image: inspirationThree,
      alt: "Quinceañera en ambiente elegante",
      label: "La magia de tus XV",
    },
  ];

  const closeModal = () => setSelectedImage(null);

  return (
    <section className="inspirationDreams" id="inspiracion">
      <div className="container">
        <div className="inspirationDreams__header">
          <span className="inspirationDreams__tag">Ideas que inspiran</span>

          <h2>Inspírate para tu gran día</h2>

          <p>
            Descubre estilos, detalles y momentos especiales que pueden ayudarte
            a imaginar la fiesta que siempre soñaste.
          </p>
        </div>

        <div className="inspirationDreams__grid">
          {galleryItems.map((item, index) => (
            <button
              key={index}
              type="button"
              className="inspirationDreams__card"
              onClick={() => setSelectedImage(item)}
              aria-label={`Ver imagen: ${item.alt}`}
            >
              <img src={item.image} alt={item.alt} />

              <div className="inspirationDreams__overlay"></div>

              <div className="inspirationDreams__caption">
                <span>{item.label}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="inspirationDreams__modal" onClick={closeModal}>
          <div
            className="inspirationDreams__modalContent"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="inspirationDreams__close"
              onClick={closeModal}
              aria-label="Cerrar imagen"
            >
              ×
            </button>

            <img src={selectedImage.image} alt={selectedImage.alt} />

            <div className="inspirationDreams__modalLabel">
              {selectedImage.label}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default InspirationGallery;